import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ExposedListDocumentTemplatesReq } from 'app/interfaces/requests/Exposed/exposedListDocumentTemplatesReq';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { SkjalamidjaService } from 'app/services/api/skjalamidja/skjalamidja.service';
import { Observable, combineLatest } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentsAddDropdownDataResolver implements Resolve<any> {
    constructor(
        private skjalamidja: SkjalamidjaService,
        private lsrauthService: LsrauthService
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        let fetchCategories = this.skjalamidja.listCategories();
        let fetchSubcategories = this.skjalamidja.listSubcategories();
        let fetchSystems = this.skjalamidja.listSystems();
        let fetchTypes = this.skjalamidja.listTypes();
        let fetchDepartments = this.lsrauthService.listDepartments();
        let fetchDivisions = this.lsrauthService.getEmployeeDivisions();
        let listDocumentTemplates = this.skjalamidja.listDocumentTemplates(true, {
            documentTemplateId: null,
            templateKey: null,
            templateTranslationKey: null,
            filterByCurrentUser: true,
        } as ExposedListDocumentTemplatesReq);

        return combineLatest([
            fetchCategories,
            fetchSubcategories,
            fetchSystems,
            fetchTypes,
            fetchDepartments,
            listDocumentTemplates,
            fetchDivisions,
        ]);
    }
}
